import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { HdContentLanguageService } from '../hd-content-language.service';

/**
 * Gedeelde leeftijd-suffix "· 13 jaar" achter een datum/tijdstip — overal
 * dezelfde weergave (gedempt, nowrap) en dezelfde vertaling
 * (`humanDesign.properties.ageValue`), of het nu de geboorterij, de
 * cycle-tijdstip-rij of de cyclus-header is. De optionele tooltip benoemt
 * de context (bv. "Leeftijd op het cyclusmoment").
 */
@Component({
  selector: 'hd-age-suffix',
  standalone: true,
  template: `<span class="hd-age-suffix" [attr.title]="tooltip() || null">· {{ text() }}</span>`,
  styles: `
    .hd-age-suffix {
      color: var(--dark-lightest);
      white-space: nowrap;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HdAgeSuffixComponent {
  /** Leeftijd in volle jaren. */
  readonly years = input.required<number>();
  readonly tooltip = input<string | null>(null);

  private readonly transloco = inject(TranslocoService);
  private readonly contentLang = inject(HdContentLanguageService);

  protected readonly text = computed(() => {
    this.contentLang.translationsLoadedTick();
    const lang = this.contentLang.effectiveLang();
    return this.transloco.translate<string>(
      'humanDesign.properties.ageValue',
      { years: this.years() },
      lang,
    );
  });
}
